<template>
    <div class="card-info-item-container" :key="data ? data.id : null">
        <div class="card-info" :style="cardInfoItemStyling">
            <InputField v-if="editingData" :key="data" :input-type="'select'" :value="data ? data.id : null" :label="editableLabel"
                :select-options-list="editableInputOptions" :size="'large'" :inputFieldContainerStyling="{ 'padding': '0' }"
                @input="updateField($event)" />
            <div class="card-info-container" :style="editingData ? 'margin-top: 20px' : ''">
                <div v-if="!editingData" class="card-info-item">
                    <v-icon class="card-icon">manage_accounts</v-icon>
                    <span class="card-info-item-label">{{ $tc('Roles', 2) }}:&nbsp;</span>
                    <span v-if="data" class="card-info-item-value">{{ data.name }} </span>
                </div>
                <div class="card-info-item">
                    <v-icon class="card-icon">label</v-icon>
                    <span class="card-info-item-label">{{ $tc('Level', 1) }}:&nbsp;</span>
                    <span v-if="data" class="card-info-item-value">{{ data.role_level }} </span>
                </div>
                <div class="card-info-item">
                    <v-icon class="card-icon">apartment</v-icon>
                    <span class="card-info-item-label">{{ $tc('Company', 1) }}:&nbsp;</span>
                    <span v-if="roleCompany" class="card-info-item-value">{{ roleCompany }} </span>
                </div>
                <div class="card-info-item">
                    <v-icon class="card-icon">devices</v-icon>
                    <span class="card-info-item-label">{{ $tc('Type', 1) }}:&nbsp;</span>
                    <span v-if="data" class="card-info-item-value">{{ data.user_type }} </span>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import CustomButton from '../_Atoms/CustomButton'
import InputField from "@/newComponents/_Atoms/InputField.vue";
import _ from 'lodash';
import { bus } from "@/main.js";

export default {
    name: "SingleEditObjectMainInfoRoles",

    components: {
        CustomButton,
        InputField,
    },

    props: {
        fields: {
            type: Array,
            default: [{

            }]
        },

        editableInputOptions: {
            type: Array,
        },

        editableLabel: {
            type: String,
        },

        editingData: {
            type: Boolean,
        },

        data: {
            type: Object,
            required: true,
        },

        roleCompany:{
            type: String,
        }
    },

    data() {
        return {
            buttonStyling: {
                'padding': '0px',
                'drop-shadow': '0.85px 0.85px 1.75px rgba(0, 0, 0, 0.25)',
                'border-radius': '4px'
            },
            actionButtonsStyling: {
                'border': '1px solid var(--app-primary-base)',
                'border-radius': '7px',
                'font-size': '10px',
                'line-height': '12px',
                'height': '20px',
                'font-weight': '600'
            },
            actionButtonsStylingSave: {
                'font-size': '10px',
                'line-height': '12px',
                'height': '20px',
                'font-weight': '600'
            },
        }
    },

    computed: {
        cardInfoItemStyling() {
            return {
                'width': this.editingData ? '100%' : 'auto',
                'margin': !this.editingData ? '10px 12px 10px 0' : ' 6px 9px 6px 0'
            }
        },

        cardHeight() {
            return 'calc(' + this.height + ' - 8px)';
        }
    },
    methods: {
        fieldIsBarcodeField(label) {
            return label === this.$i18n.t('Barcode')
        },

        updateField(event) {
            let parsedValue = event;
            const role = this.editableInputOptions.find(element => element.id === parsedValue);
            if(role){
                this.$emit("update-roles", role);
                bus.$emit("update-roles-bus", role);
            }else{
                this.$emit("update-roles", {});
                bus.$emit("update-roles-bus", {});
            }
        },
    },
}
</script>
  
<style scoped>
.object-info-card {
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 17px 21px;
    overflow-y: hidden;
}

.card-info-container {
    display: flex;
    flex-direction: column;
    gap: 3;
}

.card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 5px;
}

.title-label {
    color: var(--app-primary-base);
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 11.5px;
    text-transform: uppercase;
}

.title-reference {
    color: #767676;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 800;
    line-height: 11.5px;
    text-transform: uppercase;
}

.card-info-item-container {
    display: flex;
    flex-direction: row;
    gap: 13px;
    margin-top: 20px;
}

.card-info-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
}

.card-info-item-value,
.card-info-item-label {
    color: #767676;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 11.5px;
    white-space: nowrap;
}

.card-info-item-value {
    font-weight: 800;
}

.card-info {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-height: 87%;
}

.card-icon {
    margin-right: 8px;
}

.v-icon {
    line-height: 0;
    color: var(--app-primary-base);
    font-size: 15px;
}

::-webkit-scrollbar {
    width: 4px;
}

.buttons-container {
    display: flex;
    flex-direction: row;
    gap: 6px
}

.action-buttons {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: flex-end;
    position: absolute;
    right: 21px;
    bottom: 17px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/_Organisms/SingleEditObjectMainInfoRoles.vue